import React from 'react'
import { Helmet } from 'react-helmet-async'
import QuickStaffView from 'src/sections/user/quick-staff/view/quick-staff-view'

export default function QuickStaffPage() {
    return (
        <>
            <Helmet>
                <title> Quick Staff </title>
            </Helmet>

            <QuickStaffView />
        </>
    )
}
